var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeather3D(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 497.113 497.113",
    style: {
      enableBackground: "new 0 0 497.113 497.113"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.7336,
    y1: 627.7089,
    x2: -50.9794,
    y2: 566.913,
    gradientTransform: "matrix(7.8769 0 0 -7.8769 388.1604 4938.5537)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    style: {
      stopColor: "#E0B386"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#DA498C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#961484"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M0.89,473.001c0,0-22.008-236.497,239.451-317.306C501.799,74.933,491.528,0,491.528,0 s47.151,185.108-143.833,220.207C3.954,283.38,0.89,473.001,0.89,473.001z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -61.3116,
    y1: 551.6581,
    x2: 17.1985,
    y2: 630.3512,
    gradientTransform: "matrix(7.8769 0 0 -7.8769 388.1604 4938.5537)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    style: {
      stopColor: "#E0B386"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#DA498C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#961484"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M496.64,45.859c-4.758,20.929-37.675,84.126-255.134,151.292 C57.99,253.865,11.587,385.859,0.465,462.478c0.087,6.743,0.425,10.524,0.425,10.524S3.954,283.38,347.695,220.207 C477.633,196.34,497.325,103.07,496.64,45.859z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.5223,
    y1: 611.9309,
    x2: -50.5813,
    y2: 564.8999,
    gradientTransform: "matrix(7.8769 0 0 -7.8769 388.1604 4938.5537)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29D3DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#0077FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#064093"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#084698"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M0.787,488.858c0,0-17.038-182.942,185.226-245.453 c202.248-62.48,194.308-120.438,194.308-120.438s36.47,143.195-111.262,170.346C3.166,342.174,0.787,488.858,0.787,488.858z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -58.5746,
    y1: 553.0992,
    x2: 2.1574,
    y2: 613.9752,
    gradientTransform: "matrix(7.8769 0 0 -7.8769 388.1604 4938.5537)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29D3DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#0077FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#064093"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#084698"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M384.268,158.436c-3.686,16.203-29.145,65.079-197.356,117.035 C44.953,319.338,9.058,421.439,0.457,480.721c0.071,5.207,0.331,8.137,0.331,8.137S3.158,342.174,269.06,293.313 C369.561,274.842,384.803,202.697,384.268,158.436z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -12.4039,
    y1: 599.4106,
    x2: -50.2509,
    y2: 563.8506,
    gradientTransform: "matrix(7.8769 0 0 -7.8769 388.1604 4938.5537)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    style: {
      stopColor: "#E0B386"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#DA498C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#961484"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M0.701,497.113c0,0-12.879-138.311,140.044-185.572 c152.915-47.238,146.912-91.065,146.912-91.065s27.577,108.26-84.141,128.788C2.489,386.213,0.701,497.113,0.701,497.113z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -56.2933,
    y1: 554.9299,
    x2: -10.3763,
    y2: 600.9568,
    gradientTransform: "matrix(7.8769 0 0 -7.8769 388.1604 4938.5537)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    style: {
      stopColor: "#E0B386"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#DA498C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#961484"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    d: "M290.642,247.296c-2.788,12.249-22.04,49.199-149.213,88.481 C34.099,368.947,6.955,446.141,0.441,490.953c0.055,3.946,0.26,6.152,0.26,6.152s1.796-110.899,202.815-147.85 C279.52,335.313,291.036,280.765,290.642,247.296z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeather3D);
export default __webpack_public_path__ + "static/media/feather3d.3c523eeae0af838e91c3cadce8e33883.svg";
export { ForwardRef as ReactComponent };